module.exports = __webpack_public_path__ + "resources/img/img_xcloud_m_en.7b20ef198f4a973ca0d5c23c8939d601.png";